import CreateProjectPage from './CreateProjectPage';

export default CreateProjectPage;
